import { useState, forwardRef, useImperativeHandle, useRef } from 'react';
import { useToastContext } from '../toast/toast.context';
import { sendFile } from '../../../services/hold-document';

interface FileInputProps {
  onFileUploaded?: (filePath: string) => void; // Callback para retornar o caminho do arquivo
  pathToUpload: string;
  name?: string;
  currentPath?: string;
  nameFile?: string;
}

export const FileObservations = forwardRef<HTMLInputElement, FileInputProps>(
  ({ onFileUploaded, pathToUpload, nameFile, name, currentPath: initialCurrentPath }, ref) => {
    const inputRef = useRef<HTMLInputElement>(null);
    const [currentPath, setCurrentPath] = useState(initialCurrentPath || "");
    const { notifySuccess, notifyError } = useToastContext();

    useImperativeHandle(ref, () => inputRef.current!);

    const triggerFileSelect = () => inputRef.current?.click();

    const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
      if (event.target.files && event.target.files[0]) {
        const file = event.target.files[0];
        event.target.value = "";
        await handleSendPdf(file);
      }
    };

    async function handleSendPdf(file: File) {
      try {
        const prefix = pathToUpload;
        const data = {
          prefix,
          file,
        };

        if (name) {
          Object.assign(data, { name });
        }

        const sendFileResponse = await sendFile(data);

        if (!sendFileResponse.ok) {
          throw new Error(sendFileResponse.message || 'Erro ao enviar PDF');
        }

        const [{ key }] = sendFileResponse.data;

        setCurrentPath(key); // Atualiza o caminho local
        if (onFileUploaded) {
          onFileUploaded(key); // Retorna o caminho do arquivo ao componente pai
        }
        notifySuccess(`PDF ${file.name} enviado com sucesso`);
      } catch (error) {
        notifyError(`Erro ao enviar o PDF ${file.name}: ${error}`);
      }
    }

    return (
      <div>
        <div className="custom-file-input">
          <button
            type="button"
            className="m-2 bg-redPrimary text-white"
            onClick={triggerFileSelect}
          >
            {nameFile}
          </button>
        </div>
        <input
          type="file"
          ref={inputRef}
          onChange={handleFileChange}
          className="hidden"
        />
        {currentPath && (
          <span className="pt-4">
            <a
              href={`https://assets.locavibe.com.br/${currentPath}`}
              className="text-bluePrimary"
              target="_blank"
              rel="noopener noreferrer"
            >
              {currentPath.split('/').reverse()[0]}
            </a>
          </span>
        )}
      </div>
    );
  }
);
